import { Icon } from "@material-ui/core";
import AreaChip from "Components/Common/Chip/AreaChip";
import RoleIcon from "Components/Icon/RoleIcon";
import i18n from "i18next";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import { connect } from "react-redux";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateState } from "Store/TaskTemplates/TaskTemplateState";
import styles from "./TaskTemplateBlockDetailsBlock.scss";

interface IProps {
    taskTemplate: TaskTemplate;
    taskTemplateState: ITaskTemplateState;
}

const mapStateToProps = (state: IApplicationState) => ({
    taskTemplateState: state.taskTemplateState
});

const TaskTemplateBlockDetailsBlock: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.taskTemplateBlockDetailsBlock}>
        <div className={styles.info}>
            <div className={styles.identifier}>{i18n.t("common.id")}: {props.taskTemplate.id}</div>
            <div className={styles.link}>
                {i18n.t("common.link")}: {props.taskTemplate.deeplinkTo ? `${i18n.t(`tasks.deeplinkTo.${props.taskTemplate.deeplinkTo}`)} #${props.taskTemplate.deeplinkId}` : i18n.t("none")}
            </div>
            {props.taskTemplate.descriptionFileUrl ? (
                <div className={styles.attachment}>
                    {i18n.t("common.attachment")}: PDF
                </div>
            ) : (
                    <div className={styles.attachment}>
                        {i18n.t("common.steps")}: {props.taskTemplate.steps.length}
                    </div>
                )}
        </div>
        <h2>{props.taskTemplate.name}</h2>
        <div className={styles.bottomInfo}>
            <div className={styles.role}>
                {i18n.t("authentication.role")}: {i18n.t(`authentication.roles.${props.taskTemplate.role}`)}
            </div>
            {props.taskTemplate.area && <AreaChip area={props.taskTemplate.area} size="small" filteredArea={props.taskTemplateState.currentFilter && props.taskTemplateState.currentFilter.area} />}
        </div>
    </div>
);

export default connect(mapStateToProps, null)(TaskTemplateBlockDetailsBlock);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockCard/TaskTemplateBlockDetailsBlock/TaskTemplateBlockDetailsBlock.tsx